enum Environment {
  prod = "Prod",
  dev = "Dev",
  acceptance = "Acceptance",
}
export default Environment;
